import Error from "@/assets/images/error.svg";
import { Button, Flex, theme, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Flex
      justify="center"
      align="center"
      vertical
      gap={token.marginLG}
      style={{
        width: "100%",
        height: "100%",
        padding: token.paddingLG,
      }}
    >
      <img src={Error} alt="404 Not Found" width={300} />
      <Typography.Title level={2}>
        {t("not_found_page.page_not_found")}
      </Typography.Title>
      <Typography.Text type="secondary" style={{ fontSize: token.fontSizeLG, textAlign: "center", maxWidth: "600px" }}>
        {t("not_found_page.page_not_found_description")}
      </Typography.Text>
      <Button
        type="primary"
        size="large"
        onClick={() => {
          navigate("/");
        }}
      >
        {t("not_found_page.back_to_home")}
      </Button>
    </Flex>
  );
};

export default NotFoundPage
